/**
 * KaryawanCard Component
 * Display card for employee with photo/initials
 */

import React from "react";
import { getInitials } from "../utils/dataTransformers";

const KaryawanCard = ({ karyawan, onClick }) => {
  const handleImageError = (e) => {
    e.currentTarget.style.display = "none";
    e.currentTarget.nextSibling.style.display = "flex";
  };

  return (
    <div className="karyawan-card" onClick={() => onClick(karyawan.nik)}>
      {karyawan.photo_url ? (
        <img
          src={karyawan.photo_url}
          alt={karyawan.nama}
          className="karyawan-avatar"
          onError={handleImageError}
        />
      ) : null}
      <div
        className="karyawan-initials"
        style={{ display: karyawan.photo_url ? "none" : "flex" }}
      >
        {getInitials(karyawan.nama)}
      </div>
      <div className="karyawan-info">
        <div className="karyawan-name">{karyawan.nama}</div>
        <div className="karyawan-dept">{karyawan.departemen || "-"}</div>
      </div>
    </div>
  );
};

export default KaryawanCard;
